import NTNavbar from "@/components/feature/NTNavbar";
import NTFooter from "@/components/feature/NTFooter";
import { Link } from "react-router-dom";

const timeline = [
  { year: "2022", title: "Fundação e Primeiro Projeto", desc: "A New Tech Solution nasce com um propósito simples, mas poderoso. O primeiro passo foi a fabricação de uma picolezeira desenvolvida sob medida para atender uma necessidade específica do setor alimentício." },
  { year: "Expansão", title: "Diversificação Industrial", desc: "Ampliamos nossa atuação, desenvolvendo máquinas e equipamentos para diversos segmentos: metalúrgico, têxtil, alimentício, automobilístico e higiene pessoal, entre outros." },
  { year: "Crescimento", title: "Evolução e Consolidação", desc: "Com a evolução do mercado e o fortalecimento da nossa expertise, consolidamos nossa posição no desenvolvimento de soluções industriais personalizadas e de alto desempenho." },
  { year: "2024", title: "Foco Estratégico", desc: "A partir do segundo semestre de 2024, passamos a atuar com foco total no desenvolvimento e fabricação de máquinas e equipamentos especiais." },
  { year: "Hoje", title: "Referência Industrial", desc: "Somos especialistas em entender a necessidade de cada cliente e transformar desafios em soluções personalizadas, eficientes e de alto desempenho." },
];

const team = [
  { name: "Ricardo Almeida", role: "CEO & Fundador", image: "https://readdy.ai/api/search-image?query=professional%20CEO%20founder%20man%20portrait%20corporate%20headshot%20confident%20smile%20clean%20white%20background%20executive%20suit&width=300&height=300&seq=ntteam1&orientation=squarish" },
  { name: "Mariana Costa", role: "Diretora de Engenharia", image: "https://readdy.ai/api/search-image?query=professional%20woman%20engineer%20director%20portrait%20corporate%20headshot%20confident%20smile%20clean%20white%20background%20executive&width=300&height=300&seq=ntteam2&orientation=squarish" },
  { name: "Felipe Santos", role: "Gerente de Projetos", image: "https://readdy.ai/api/search-image?query=professional%20man%20project%20manager%20portrait%20corporate%20headshot%20confident%20smile%20clean%20white%20background%20executive&width=300&height=300&seq=ntteam3&orientation=squarish" },
  { name: "Juliana Ferreira", role: "Diretora Comercial", image: "https://readdy.ai/api/search-image?query=professional%20woman%20commercial%20director%20portrait%20corporate%20headshot%20confident%20smile%20clean%20white%20background%20executive&width=300&height=300&seq=ntteam4&orientation=squarish" },
];

const values = [
  { icon: "ri-medal-line", title: "Qualidade e Confiabilidade", desc: "Equipamentos robustos, precisos e duráveis, entregues com excelência em cada etapa do processo." },
  { icon: "ri-shield-check-line", title: "Parceria e Transparência", desc: "Relacionamento próximo com clientes e fornecedores, baseado em confiança, colaboração e comunicação clara." },
  { icon: "ri-links-line", title: "Parceria", desc: "Relacionamento de longo prazo baseado em transparência e confiança mútua." },
  { icon: "ri-lightbulb-line", title: "Inovação Constante", desc: "Buscamos tecnologias e soluções que antecipem as necessidades da indústria e impulsionem o futuro dos nossos clientes." },
  { icon: "ri-heart-line", title: "Paixão pelo Desenvolvimento", desc: "Transformar ideias em máquinas funcionais é o que nos move todos os dias." },
  { icon: "ri-global-line", title: "Transparência", desc: "Comunicação clara e honesta em todas as etapas do projeto." },
];

export default function SobrePage() {
  return (
    <div className="min-h-screen bg-white font-inter">
      <NTNavbar />
      <main className="pt-[88px]">

        {/* Hero */}
        <section className="relative h-[340px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=industrial%20factory%20team%20meeting%20engineers%20discussing%20project%20bright%20modern%20office%20manufacturing%20plant%20professional&width=1400&height=400&seq=ntsobreh1&orientation=landscape"
            alt="Sobre a New Tech Solution"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/80 via-[#1a1a1a]/50 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="flex items-center gap-2 mb-3">
                <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">Home</Link>
                <span className="text-white/40 text-sm">/</span>
                <span className="text-[#3FA7D6] text-sm font-semibold">Sobre</span>
              </div>
              <h1 className="font-rajdhani font-bold text-white text-4xl md:text-5xl">Sobre a New Tech Solution</h1>
              <p className="text-white/70 text-base mt-2">Conheça nossa história, missão e os valores que nos guiam.</p>
            </div>
          </div>
        </section>

        {/* Mission / Vision / Values cards */}
        <section className="bg-[#f5f5f5] py-14">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { icon: "ri-focus-3-line", title: "Missão", text: "Transformar ideias em realidade, desenvolvendo soluções sob medida que nascem de necessidades reais e impulsionam o crescimento dos nossos clientes. Mais do que fabricar máquinas, buscamos fazer parte da evolução de cada negócio." },
                { icon: "ri-eye-line", title: "Visão", text: "Ser referência global em soluções industriais personalizadas, liderando a transformação tecnológica da indústria e inspirando inovação, produtividade e crescimento sustentável em todos os setores que atendemos." },
                { icon: "ri-star-line", title: "Valores", text: "Qualidade, confiabilidade, parceria, transparência, paixão pelo desenvolvimento e inovação constante." },
              ].map((item) => (
                <div key={item.title} className="bg-white rounded-lg p-8 border border-gray-100 hover:border-[#1B1F5E] transition-all text-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mx-auto mb-4">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-xl mb-3">{item.title}</h3>
                  <p className="text-[#666] text-sm leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About text + image */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              <div>
                <p className="text-[#1B1F5E] font-bold text-sm uppercase tracking-widest mb-2">Nossa História</p>
                <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-4xl leading-tight mb-5">
                  De uma picolezeira a<br /><span className="text-[#1B1F5E]">referência industrial</span>
                </h2>
                <p className="text-[#555] text-sm leading-relaxed mb-4">
                  Nossa história começou com um propósito simples, mas poderoso: criar, inovar e desenvolver soluções que realmente fazem a diferença. O primeiro passo foi a fabricação de uma picolezeira — máquina para congelamento de picolés —, desenvolvida sob medida para atender uma necessidade específica do setor alimentício. Esse projeto marcou o início de uma trajetória de crescimento, inovação e dedicação.
                </p>
                <p className="text-[#555] text-sm leading-relaxed mb-4">
                  Ao longo dos anos, ampliamos nossa atuação, desenvolvendo máquinas e equipamentos para diversos segmentos industriais: metalúrgico, têxtil, alimentício, automobilístico, higiene pessoal, entre outros.
                </p>
                <p className="text-[#555] text-sm leading-relaxed mb-8">
                  Com a evolução do mercado e o fortalecimento da nossa expertise, demos um passo estratégico: a partir do segundo semestre de 2024, passamos a atuar com foco total no desenvolvimento e fabricação de máquinas e equipamentos especiais. Mais do que fabricar máquinas, entregamos tecnologia, inovação e resultados — e somos parceiros dos nossos clientes no crescimento e na busca por maior produtividade e competitividade.
                </p>
                <div className="grid grid-cols-3 gap-4">
                  {[{ num: "2022", label: "Fundação" }, { num: "5+", label: "Segmentos" }, { num: "100%", label: "Sob Medida" }].map((s) => (
                    <div key={s.label} className="text-center border border-gray-200 rounded-lg py-4">
                      <p className="font-rajdhani font-bold text-[#1B1F5E] text-3xl leading-none">{s.num}</p>
                      <p className="text-[#999] text-xs mt-1">{s.label}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="w-full h-[460px] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=industrial%20factory%20production%20line%20workers%20engineers%20bright%20clean%20modern%20manufacturing%20plant%20professional%20Brazil&width=700&height=500&seq=ntsobrec1&orientation=portrait"
                  alt="New Tech Solution fábrica"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="bg-[#f5f5f5] py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <p className="text-[#1B1F5E] font-bold text-sm uppercase tracking-widest mb-2">Nossa Trajetória</p>
              <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-4xl md:text-5xl">Linha do Tempo</h2>
            </div>
            <div className="relative">
              <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-[#1B1F5E]/20 hidden md:block"></div>
              <div className="flex flex-col gap-8">
                {timeline.map((item, idx) => (
                  <div key={item.year} className={`flex flex-col md:flex-row items-center gap-6 ${idx % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                    <div className={`flex-1 ${idx % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                      <div className={`bg-white rounded-lg p-6 border border-gray-200 hover:border-[#1B1F5E] transition-all inline-block w-full md:max-w-sm ${idx % 2 === 0 ? "md:ml-auto" : ""}`}>
                        <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-lg mb-1">{item.title}</h3>
                        <p className="text-[#666] text-sm leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1B1F5E] text-white font-rajdhani font-bold text-sm shrink-0 z-10">
                      {item.year}
                    </div>
                    <div className="flex-1 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <p className="text-[#1B1F5E] font-bold text-sm uppercase tracking-widest mb-2">O que nos move</p>
              <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-4xl md:text-5xl">Nossos Valores</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {values.map((v) => (
                <div key={v.title} className="border border-gray-200 rounded-lg p-7 hover:border-[#1B1F5E] transition-all group">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mb-4 group-hover:bg-[#1B1F5E] group-hover:text-white transition-all">
                    <i className={`${v.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-lg mb-2">{v.title}</h3>
                  <p className="text-[#666] text-sm leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#f5c518] py-5">
          <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-rajdhani font-black text-[#1a1a1a] text-xl md:text-2xl uppercase">VAMOS TRABALHAR JUNTOS?</p>
              <p className="text-[#1a1a1a]/70 text-sm mt-0.5">Entre em contato e descubra como podemos transformar sua produção.</p>
            </div>
            <Link to="/contato" className="whitespace-nowrap bg-[#1a1a1a] hover:bg-[#333] text-white font-bold px-8 py-3 rounded-md transition-colors cursor-pointer text-sm">
              Fale Conosco
            </Link>
          </div>
        </section>

      </main>
      <NTFooter />
    </div>
  );
}